<template>
  <div class="product-inform-availability">
    <ModalComponentHeader>
      {{ productMessages?.informAvailability }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <h5 class="product-inform-availability__title">
        {{ result.messages.title }}
      </h5>
      <p class="product-inform-availability__text">{{ result.messages.description }}</p>
      <DefButtonPrimary @click="modal.hide()"> ОК </DefButtonPrimary>
    </ModalComponentBody>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import { useStore } from '@/store';

const { state } = useStore();
const modal = useModal();

const { result } = defineProps(['result']);

const productMessages = computed(() => state.product.data.messages);
</script>

<script>
export default {
  name: 'ProductInformAvailability',
};
</script>

<style lang="scss" scoped>
.product-inform-availability {
  text-align: center;
  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: 16px;
      margin-bottom: 16px;
    }
  }
  &__text {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    color: #5f5f67;
    @include point-md {
      font-size: 16px;
      margin-bottom: 24px;
    }
  }
  :deep(.def-button-primary) {
    width: 100%;
  }
}
</style>
